import { useRouter } from 'next/router'
import { useQuery } from 'react-query'
import { isEmpty } from 'lodash-es'

// Libs
import { fetchPchomeProductData } from '@/api/fetchPchomeProductData'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'

interface UseExternalProductDataProps {
  roomId: string
  isExternalProductData: boolean
}

export const useExternalProductData = ({ roomId, isExternalProductData }: UseExternalProductDataProps) => {
  const router = useRouter()

  const { data: productList = [], isSuccess: isProductListSuccess } = useQuery(
    [QUERY_KEY.FETCH_PCHOME_PRODUCT_DATA, { roomId }],
    () => fetchPchomeProductData({ roomId }),
    {
      enabled: router.isReady && !isEmpty(roomId) && isExternalProductData,
    },
  )

  return {
    externalProductList: isProductListSuccess ? productList : [],
  }
}
